'use client'

import styles from './LoginForm.module.css'

import React, { useState, useRef } from 'react'

import { useAppDispatch } from '@/lib/hook'
import { notifyContainerActions } from '@/lib/store'

import Button from '@/components/ui/Button'
import Input from '@/components/ui/Input'
import { ICONS } from '@/components/ui/Icon'
import { signIn, sendTwoFactorCode } from '@/server/signIn'
import { redirect } from 'next/navigation'

export default function LoginForm() {
    const dispatch = useAppDispatch()
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [enterTwoFactor, setEnterTwoFactor] = useState(false)

    const emailRef = useRef<HTMLInputElement>(null)
    const passwordRef = useRef<HTMLInputElement>(null)
    const loginFormRef = useRef<HTMLFormElement>(null)
    const twoFARef = useRef<HTMLInputElement>(null)

    function handleInputChange() {
        if (error.length !== 0) {
            setError('')
        }
    }

    const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
        if (enterTwoFactor) {
            e.preventDefault()
            setLoading(true)

            const code = twoFARef!.current!.value

            const { success, message, url } = await sendTwoFactorCode(code)

            setLoading(false)

            if (!success) {
                setError(message)
                dispatch(notifyContainerActions.addNotification({ type: 'error', message }))
            } else {
                redirect(url)
            }

            return
        }

        e.preventDefault()
        setLoading(true)

        const email = emailRef!.current!.value
        const password = passwordRef!.current!.value

        const { needTwoFactor, success, message, url } = await signIn(email, password)

        if (needTwoFactor) {
            setEnterTwoFactor(true)
            setLoading(false)
            return
        }

        setLoading(false)

        if (!success) {
            setError(message)
            dispatch(notifyContainerActions.addNotification({ type: 'error', message }))
        } else {
            redirect(url)
        }
    }

    return (
        <form className={styles['login-form']} ref={loginFormRef} onSubmit={handleLogin} autoComplete='on'>
            {!enterTwoFactor ? (
                <div className={styles['login-inputs']} key='login-fields'>
                    <Input name='login-email' label='E-Mail' labelIcon={ICONS.EMAIL} type='email' ref={emailRef} onChange={handleInputChange} autoComplete='email' />
                    <Input name='login-password' label='Password' labelIcon={ICONS.PASSWORD} type='password' ref={passwordRef} onChange={handleInputChange} autoComplete='current-password' />
                </div>
            ) : (
                <div className={styles['login-inputs']} key='2fa-field'>
                    <Input name='twoFA-code' label='2FA Code' labelIcon={ICONS.KEY} type='number' ref={twoFARef} onChange={handleInputChange} autoComplete='one-time-code' />
                </div>
            )}

            {error && <p className={styles['error']}>{error}</p>}

            <div className={styles['login-button-container']}>
                <Button icon={ICONS.LOGIN} label={loading ? 'Logging in...' : 'Login'} disabled={loading} long />
            </div>
        </form>
    )
}
